import inquireService from '../services/inquire.service';

// methods - temp cart
const cs_getInquireList = async () => {
  try {
    let res = await inquireService.getInquireList();

    return {
      inquireList:
        (res.data &&
          res.data.map((item) => ({
            tempId: item.id,
            ...item.product,
            qty: item.qty,
            remark: '',
          }))) ||
        [],
    };
  } catch (error) {
    console.error(error);
  }
};

const cs_addToInquire = async (rootState, item) => {
  let itemList = [];
  const { id, qty, remark } = item;
  itemList.push({
    productId: id,
    qty: qty || 1,
    remark,
    registerId: rootState.auth.user.registerDTO.id,
    sellerId: item.register.id,
  });

  try {
    let res = await inquireService.registerToInquire(itemList);

    return res.data && res.data.length > 0 && res.data[0]
      ? res.data[0].id
      : null;
  } catch (error) {
    console.error(error);
  }
};

const cs_removeFromInquire = async (tempId) => {
  try {
    await inquireService.removeFromInquire([tempId]);
  } catch (error) {
    console.error(error);
  }
};

const cs_clearCart = async () => {
  try {
    await inquireService.checkout();
  } catch (error) {
    console.error(error);
  }
};

// calcuate item price by conditons
const cs_getItemWithPrice = (item, isLoggedIn) => {
  let isBaseUnit = true;
  let appliedUnit = { name: 'Basic', id: null };

  if (item.productUnits && item.productUnits.length > 0) {
    // check multi unit
    let pUnitArrLen = item.productUnits.length;
    let pUnitItem = null;

    for (let index = 0; index < pUnitArrLen; index++) {
      pUnitItem = null;

      // check last or between, and get unit
      if (
        (index == pUnitArrLen - 1 &&
          item.qty >= item.productUnits[index].factor) ||
        (item.qty >= item.productUnits[index].factor &&
          item.qty < item.productUnits[index + 1].factor)
      )
        pUnitItem = item.productUnits[index];

      // set price
      if (pUnitItem) {
        if (item.isSpecialOffer) item.price = pUnitItem.unitSpecialPrice;
        else if (item.isPromo) item.price = pUnitItem.unitPromoPrice;
        else item.price = pUnitItem.unitPrice;

        isBaseUnit = false; // to announce to use other unit's price
        appliedUnit.id = pUnitItem.id;
        appliedUnit.name = pUnitItem.factorUnitName;
        break;
      }
    }
  }

  if (isBaseUnit) {
    if (item.isPromo && item.isSpecialOffer && item.specialOfferPrice)
      item.price = item.specialOfferPrice;
    else if (item.isSpecialOffer && item.specialOfferPrice)
      item.price = item.specialOfferPrice;
    else if (item.isPromo && item.promoPrice) item.price = item.promoPrice;
    else if (isLoggedIn) item.price = item.minPrice;
    else item.price = item.maxPrice;
  }

  return {
    ...item,
    amount: item.price * item.qty,
    appliedUnit,
  };
};
// end - methods - temp cart

const qtyRegx = /^[0-9]{1,7}$/;

const state = {
  inquireList: [],
};

const getters = {
  itemCount: (state) => state.inquireList.length,
  inquireListByShopGroup: (state, getters, rootState) => {
    return state.inquireList.reduce((results, item) => {
      //
      item = cs_getItemWithPrice(item, rootState.auth.status.loggedIn);

      let sellerIndex = results.findIndex((i) => i.shop.id == item.registerId);

      if (sellerIndex < 0) {
        // create seller
        results.push({
          shop: item.register,
          inquireItems: [item],
          totalAmount: item.amount,
        });
      } else {
        // add seller cart item
        results[sellerIndex].inquireItems.push(item);
        results[sellerIndex].totalAmount += item.amount;
      }

      return results;
    }, []);
  },
};

const actions = {
  async getInquireList({ commit }) {
    try {
      let data = await cs_getInquireList();
      commit('setInquire', data.inquireList || []);
    } catch (error) {
      console.error(error);
    }
  },
  async addToInquire({ commit, state, rootState }, product) {
    const index = state.inquireList.findIndex((item) => item.id === product.id);
    if (index < 0) {
      // new
      let tempId = await cs_addToInquire(rootState, product); // register as temp
      commit('addItemToInquire', { ...product, tempId });
    } else {
      // existed
      commit('increaseInquireItemQtyByQty', { index, qty: product.qty });
    }
  },
  updateInquireItemQty({ commit, state }, { type, product }) {
    const index = state.inquireList.findIndex(
      (inquireItem) => inquireItem.id === product.id
    );

    if (index > -1) {
      if (type == 'INCREASE') commit('increaseCartItemQty', index);
      else if (type == 'DECREASE') commit('decreaseCartItemQty', index);
      else commit('updateInquireItemQty', { product, index });
    }
  },
  removeFromInquire({ commit, state }, { id, tempId }) {
    const index = state.inquireList.findIndex((inquireItem) => inquireItem.id === id);

    if (index > -1) {
      commit('removeItemFromInquire', index);

      // remove from temp
      cs_removeFromInquire(tempId);
    }
  },
  clearCart({ commit }) {
    commit('clearCart');
    // clear temp cart
    cs_clearCart();
  },

  clearOrderedItem({ commit }, orderList = []) {
    orderList.forEach((order) => {
      order.orderDetailList.forEach((orderItem) => {
        const index = state.inquireList.findIndex(
          (inquireItem) => inquireItem.id === orderItem.productId
        );

        if (index > -1) {
          const inquireItem = state.inquireList[index];

          if (inquireItem) {
            commit('removeItemFromInquire', index);
            // remove from temp
            if (inquireItem.tempId) cs_removeFromInquire(inquireItem.tempId);
          }
        }
      });
    });
  },
};

const mutations = {
  addItemToInquire(state, item) {
    if (item.qty && qtyRegx.test(item.qty)) state.inquireList.push(item);
    else state.inquireList.push({ ...item, qty: 1 });
  },
  removeItemFromInquire(state, index) {
    state.inquireList.splice(index, 1);
  },
  increaseCartItemQty(state, index) {
    if (qtyRegx.test(state.inquireList[index].qty + 1))
      state.inquireList[index].qty++;
  },
  decreaseCartItemQty(state, index) {
    if (state.inquireList[index].qty > 1) state.inquireList[index].qty--;
  },
  increaseInquireItemQtyByQty(state, { index, qty }) {
    if (qtyRegx.test(state.inquireList[index].qty + qty))
      state.inquireList[index].qty += qty;
  },
  updateInquireItemQty(state, { product, index }) {
    if (qtyRegx.test(product.qty)) state.inquireList[index].qty = product.qty;
    else state.inquireList[index].qty = 1;
  },
  clearCart(state) {
    state.inquireList = [];
  },
  setInquire(state, inquireList) {
    state.inquireList = inquireList;
  },
};

export const inquire = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
